import { FC } from 'react';
import { ContentStyled } from './style';

const Content: FC = ({ children, ...restProps }) => <ContentStyled {...restProps}>{children}</ContentStyled>;

export default Content;
